module.exports = __webpack_public_path__ + "img/item-info-icon8.9b867556.svg";